import React, { useState } from 'react';
import { Dialog } from '@blueprintjs/core';
import { Button, TextAreaLimited } from 'components';
import { useMutation } from '@apollo/client';
import { BLOCK_DATA_FIX_MUTATION } from 'gql';
import { useModal } from 'providers/modalProvider';
import { useToast } from 'providers/toastProvider';
import { useIntl } from 'react-intl';
import { path } from 'ramda';
import { buildActionSummary } from 'utils/dataFixSummary';

const BlockDataFixModal = () => {
  const { modalDispatch, modalState } = useModal();
  const { showToast } = useToast();
  const { formatMessage } = useIntl();
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  const { row, refetch } = path(['payload'], modalState) ?? {};

  const closeModal = () => modalDispatch({ type: 'CLOSE_ALL' });

  const [block, { loading }] = useMutation(BLOCK_DATA_FIX_MUTATION, {
    onCompleted: () => {
      showToast({
        message: formatMessage({
          id: 'containers.dataFixes.modals.block.success',
        }),
      });
      closeModal();
      refetch?.();
    },
    onError: () =>
      showToast({
        message: formatMessage({ id: 'containers.all.error' }),
        icon: 'error',
      }),
  });

  const handleBlock = () => {
    if (!reason.trim()) {
      setError(
        formatMessage({ id: 'containers.dataFixes.modals.block.reason' }),
      );
      return;
    }
    block({ variables: { input: { id: row.id, reason } } });
  };

  return (
    <Dialog
      isOpen={modalState?.open}
      title={formatMessage({ id: 'containers.dataFixes.modals.block.title' })}
      onClose={closeModal}
      canOutsideClickClose={false}
    >
      <div className="bp3-dialog-body">
        <p>
          <strong>{buildActionSummary(row)}</strong>
        </p>
        <TextAreaLimited
          onChange={(e) => {
            setReason(e.target.value);
            setError('');
          }}
          value={reason}
          placeholder={formatMessage({
            id: 'containers.dataFixes.modals.block.reason',
          })}
          maxLength="500"
          showMaxLength
          error={error}
          className="mgt-10"
        />
      </div>
      <div className="bp3-dialog-footer-actions">
        <Button
          outlined
          text={formatMessage({ id: 'containers.all.btn.cancel' })}
          onClick={closeModal}
          disabled={loading}
        />
        <Button
          intent="Danger"
          text={formatMessage({ id: 'containers.dataFixes.actions.block' })}
          onClick={handleBlock}
          loading={loading}
        />
      </div>
    </Dialog>
  );
};

export default BlockDataFixModal;
